import Typography from '@mui/material/Typography';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';

class DescricaoClasseProcesso extends ReactComponent {
    get registro() {
        return this.observableProps.registro;
    }

    descricaoClasseProcesso(classe) {
        return this.dominioStore.descricaoClasseProcesso(this.registro.processo.origem, classe);
    }

    render() {
        const classes = this.registro.classeProcesso.split('-');

        if (classes.length > 1) {
            return (
                <Typography display="inline">
                    {classes.map((classe, index) => {
                        return this.descricaoClasseProcesso(classe) + (index + 1 < classes.length ? ' de ' : '');
                    })}
                </Typography>
            );
        }

        return <Typography display="inline">{this.descricaoClasseProcesso(this.registro.classeProcesso)}</Typography>;
    }
}

export default inject('stores')(observer(DescricaoClasseProcesso));
